import {
  DatePickerFormField,
  OccurrenceCountFormField,
  RepetitionIntervalSelectFormField,
  UpdateTermineFormProps,
  WeekdayOccurrenceSelectFormField,
  WeekdaySelectFormField,
} from '@/domain/termine/features/UpdateTermin';
import {
  IndividuelleWiederholung,
  TerminWiederholungsIntervall,
} from '@/domain/termine/shared/types';
import { getFixedWeekday } from '@/domain/termine/shared/utils/getWeekdaySelection';
import { IndividuellerWiederholungsText } from '@/domain/termine/shared/utils/IndividuellerWiederholungsText';
import { Card, CardContent } from '@e2n/ui';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

export function IndividualRepetitionCard({ form }: UpdateTermineFormProps) {
  const { t } = useTranslation();

  return (
    <Card className="bg-neutrals-200">
      <CardContent className="space-y-4 p-4">
        <div className="space-y-2.5">
          <p className="text-xs font-bold text-neutrals-900">
            {t('domain.termine.form.wiederholungLabel')}
          </p>

          <div className="flex flex-row gap-4">
            <OccurrenceCountFormField form={form} />
            <RepetitionIntervalSelectFormField form={form} />
          </div>
        </div>
        <form.Subscribe
          selector={(state) => state.values.wiederholungsIntervall}>
          {(wiederholungsIntervall) =>
            wiederholungsIntervall === TerminWiederholungsIntervall.MONAT ||
            wiederholungsIntervall === TerminWiederholungsIntervall.JAHR ? (
              <WeekdayOccurrenceSelectFormField form={form} />
            ) : (
              wiederholungsIntervall === TerminWiederholungsIntervall.WOCHE && (
                <WeekdaySelectFormField form={form} />
              )
            )
          }
        </form.Subscribe>
        <DatePickerFormField name="wiederholungBis" form={form} />
        <div className="min-w-0">
          <form.Subscribe selector={(state) => state.values}>
            {(iw) => {
              const wiederholung: IndividuelleWiederholung = {
                occurrenceCount: iw.occurrenceCount ?? 1,
                weekDayOccurrence: iw.wochentagAuftreten,
                wochentage: iw.wochentagAuswahl
                  ? iw.wochentagAuswahl
                  : [getFixedWeekday(dayjs(iw.datum))],
                wiederholungsIntervall: iw.wiederholungsIntervall,
              };
              return (
                <div className="text-xs text-neutrals-800 font-normal">
                  <IndividuellerWiederholungsText
                    wiederholung={wiederholung}
                    wiederholungBis={iw.wiederholungBis}
                    datum={iw.datum}
                  />
                </div>
              );
            }}
          </form.Subscribe>
        </div>
      </CardContent>
    </Card>
  );
}
